export const normalizeOptions = (value) => {
  const newValue = {};
  const isArray = Array.isArray(value);
  if (isArray) {
    Object.values(value).forEach((item) => {
      newValue[item.id] = item.name;
    });
  }
  else {
    Object.entries(value).forEach(([id, name]) => {
      newValue[id] = name;
    });
  }

  return newValue;
};

export const shallowCompare = (obj1, obj2) =>
  Object.keys(obj1).length === Object.keys(obj2).length &&
  Object.keys(obj1).every(key =>
    obj2.hasOwnProperty(key) && obj1[key] === obj2[key]
);

// From https://github.com/hirak/phpjs/blob/master/functions/strings/strip_tags.js.
function strip_tags(input, allowed) {
  //  discuss at: http://phpjs.org/functions/strip_tags/
  // original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // improved by: Luke Godfrey
  // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  //    input by: Pul
  //    input by: Alex
  //    input by: Marc Palau
  //    input by: Brett Zamir (http://brett-zamir.me)
  //    input by: Bobby Drake
  //    input by: Evertjan Garretsen
  // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // bugfixed by: Onno Marsman
  // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // bugfixed by: Eric Nagel
  // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // bugfixed by: Tomasz Wesolowski
  //  revised by: Rafał Kukawski (http://blog.kukawski.pl/)
  //   example 1: strip_tags('<p>Kevin</p> <br /><b>van</b> <i>Zonneveld</i>', '<i><b>');
  //   returns 1: 'Kevin <b>van</b> <i>Zonneveld</i>'
  //   example 2: strip_tags('<p>Kevin <img src="someimage.png" onmouseover="someFunction()">van <i>Zonneveld</i></p>', '<p>');
  //   returns 2: '<p>Kevin van Zonneveld</p>'
  //   example 3: strip_tags("<a href='http://kevin.vanzonneveld.net'>Kevin van Zonneveld</a>", "<a>");
  //   returns 3: "<a href='http://kevin.vanzonneveld.net'>Kevin van Zonneveld</a>"
  //   example 4: strip_tags('1 < 5 5 > 1');
  //   returns 4: '1 < 5 5 > 1'
  //   example 5: strip_tags('1 <br/> 1');
  //   returns 5: '1  1'
  //   example 6: strip_tags('1 <br/> 1', '<br>');
  //   returns 6: '1 <br/> 1'
  //   example 7: strip_tags('1 <br/> 1', '<br><br/>');
  //   returns 7: '1 <br/> 1'

  allowed = (((allowed || '') + '')
      .toLowerCase()
      .match(/<[a-z][a-z0-9]*>/g) || [])
    .join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
  var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
    commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
  return input.replace(commentsAndPhpTags, '')
    .replace(tags, function($0, $1) {
      return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
    });
}

export const sanitizeDomain = (value) => {
  // Define disallowed characters for domains.
  const disallowed = ['<', '>', '(', ')', '{', '}', '[', ']', ';', '*', '=', ',', '+', '$', '^', '@', '!', '%'];
  let sanitized = strip_tags(value.trim());
  sanitized.replace(/\s+/, '');
  disallowed.map(v => sanitized.replace(v, ''))
  // console.log(sanitized)

  return sanitized;
};

export const validateDomain = (value) => {
  const re = /^(?=.{1,254}$)((?=[a-z0-9-]{1,63}\.)(xn--+)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}$/i;
  const matches = re.exec(value);
  if (matches) {
    return true;
  }
  return false;
};

// Returns symbolic names for DMARC report email addresses.
export const makeSymbolicName = (name) => {
  let str = name.toLowerCase(); // Lowercase
  str = str.replace("'", ''); // Remove apostrophes
  str = str.replace(/^the/, ''); // Remove 'the' from beginning
  str = str.replace(/\b(?:inc|incorporated|ltd|group|co|corp|corporation|company|companies|\.com)\b/, '');
  str = str.replace(/(?:n\.a\.|s\.a\.|ag|as)$/, '');
  str = str.replace(/[\s+]$/, ''); // Remove trailing whitespace
  str = str.replace(/[^A-Za-z0-9 ]/, ''); // Remove all non-alphanumeric, BUT retain spaces
  str = str.replace(/\s+/, '-');
  return str;
};

// See if a particular error exists
export const hasError = (errors, str) => {
  let found = false;

  if (errors !== undefined) {
    str = str.toLowerCase();
    errors.forEach(error => {
      error = error.toLowerCase();
      if (error.indexOf(str) != -1) {
        found = true
      }
    });
  }

  return found;
};

// Recursive function to parse the JSON and generate a list of errors.
export const recursiveError = (array_values, children) => {
  if (!Array.isArray(array_values)) {
    return false;
  }

  let errors = [];
  let count  = 1;
  if (count >= 500) return;

  for (const item of array_values) {
    if (item.errors) {
      for (const error of item.errors) {
        errors.push(error);
        count++;
      }
    }
    if (item[children] != undefined) {
      recursiveError(item[children]);
    }
  }
  return errors;
};

// Recursive function to parse the JSON and generate a list of errors.
export const countDNS = (mechanisms) => {
  if (!Array.isArray(mechanisms)) {
    return 0;
  }

  const dns = ['include', 'a', 'mx', 'ptr', 'exists', 'redirect'];
  let count  = 1;

  if (count >= 500) return;

  for (const mechanism of mechanisms) {
    if (mechanism.mechanism) {
      let str = mechanism.mechanism.trim().replace(/[^A-Za-z0-9\-]/, '');
      if (dns.indexOf(str)) {
        count++;
      }
      if (mechanism.nested_record != undefined) {
        countDNS(mechanism.nested_record);
      }
    }
  }
};

export const hubspotLeadSubmit = async (values, context, GUID) => {
  try {
    const hubspot_portal_id = '3478499';
    const form_guid = GUID;

    const formBody = {
      fields: Object.entries(values).map(([name, value]) => ({ name, value })),
      context: context,
    }
    console.log(formBody);
    
    const response = await fetch(
      `https://api.hsforms.com/submissions/v3/integration/submit/${hubspot_portal_id}/${form_guid}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formBody),
      }
    );

    if (response.ok) {
      console.log('Form submission successful');
      // Handle success (e.g., show a success message, redirect, etc.)
    } else {
      console.error('Form submission failed');
      // Handle error (e.g., show an error message)
    }
  } catch (error) {
    console.error('Error submitting form', error);
  }
};
